import { render, staticRenderFns } from "./GuardaTramite.vue?vue&type=template&id=04be7d42&"
import script from "./GuardaTramite.vue?vue&type=script&lang=js&"
export * from "./GuardaTramite.vue?vue&type=script&lang=js&"
import style0 from "./GuardaTramite.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VDialog,VIcon})
